import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {
	TenantVerificationTransmissionService
} from "../../raintree/transmission/tenant-verification-transmisssion/tenant-verification-transmission.service";
import {AuthMessageService} from "../auth-message.service";
import {ToastMessageService} from "../../services/toast-message.service";
import {AuthTransmissionService} from "../../raintree/transmission/auth-transmission/auth-transmission.service";
import {AuthProviderEnum} from "../enum/auth-provider-enum";
import {AuthenticationService} from "../authentication.service";
import {Auth0Service} from "../../auth0.service";

@Component({
	selector: 'fb-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	public passwordType: 'password' | 'text' = 'password';
	@Output()
	public authProvider: EventEmitter<AuthProviderEnum> = new EventEmitter<AuthProviderEnum>();

	@Input()
	public emailFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.email
	]);

	public passwordFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(8),
		Validators.maxLength(38)
	]);

	public loginFormGroup: FormGroup = new FormGroup({
		username: this.emailFormControl,
		password: this.passwordFormControl
	});

	public loginFailure: boolean = false;

	constructor(
		private _tenantTransmission: TenantVerificationTransmissionService,
		private _authTransmission: AuthTransmissionService,
		private _fabricAuth: AuthenticationService,
		public authMessage: AuthMessageService,
		private _toast: ToastMessageService,
		private _auth0: Auth0Service
	) {
	}

	ngOnInit() {
	}
	public getAuthProvider(provider: AuthProviderEnum): void {
		this.authProvider.emit(
			provider
		)
	}
	public basicLogin(): void {
		if(this.emailFormControl.valid && this.passwordFormControl.valid) {
			this.loginRequest(
				this.emailFormControl.value,
				this.passwordFormControl.value
			)
		}
		else {
			this.emailFormControl.markAsDirty();
			this.passwordFormControl.markAsDirty();
			this._toast.error(
				'Fields are empty.',
				'Please fill up all the required fields.'
			)
		}
	}

	public loginRequest(username: string, password: string): void {
		this.loginFailure = false;
		this._fabricAuth.authenticateEmail(
			username.trim().toLowerCase(),
			password,
			() => {
				this._toast.success('Logged In Successfully', 'User logged in successfully');
				this.loginFormGroup.reset();
			},
			(error) => {
				this._toast.error(error,error);
				if(error.includes("password")) {
					this.loginFailure = true;
				}

			},
			() => {

			}
		)
	}


	public readonly AuthProviderEnum = AuthProviderEnum;
}
